import { DateTime } from "luxon";
import { Localization } from "material-table";
import { ParticipantType, Registration, CanvasQuality } from "./GeneratedTypes";
import { OptionsObject, SnackbarKey, SnackbarMessage } from "notistack";

export interface MentorAccess {
    token: string;
    expiration: DateTime;
}

export interface MentorData {
    mentorAccess: MentorAccess;
}

type LocalizationSchema = typeof import("./localizations.json");
type LocalizationKeys = keyof LocalizationSchema["en-US"];
export type Localizations = Record<LocalizationKeys, string>;

type MentorLocalizationSchema = typeof import("./mentorLocalizations.json");
type MentorLocalizationKeys = keyof MentorLocalizationSchema["en-US"];
export type MentorLocalizations = Record<MentorLocalizationKeys, string> & Localization;

type ObserverLocalizationSchema = typeof import("./observerLocalizations.json");
type ObserverLocalizationKeys = keyof ObserverLocalizationSchema["en-US"];
export type ObserverLocalizations = Record<ObserverLocalizationKeys, string> & Localization;

export interface User {
    id: string;
    firstName: string;
    lastName: string;
    // email: string;
}

export const EmptyGuid = "00000000-0000-0000-0000-000000000000";
export interface InputInfo {
    id: string;
    name: string;
    selected: boolean;
}

export interface ObserverState {
    registrations: Registration[];
    newObserverPresent: boolean;
}

// export interface Chat {
//     author: string;
//     text: string;
//     created: Date;
//     isMentor: boolean;
// }

// export interface Photo {
//     id: string;
//     url: string | null;
//     dateTaken: Date;
//     tags: PhotoTag[];
// }

// export interface PhotoTag {
//     author: string;
//     dateAdded: Date;
//     value: string;
//     id: string;
//     position: Position;
// }

// type Position = {
//     x: number;
//     y: number;
// };

export interface LiveSwitchState {
    remoteVideoDevices: InputInfo[];
    localVideoDevices: InputInfo[];
    localAudioInputs: InputInfo[];
    localAudioOutputs: InputInfo[];
    guestSessionActive: boolean;
    sessionId: string | null;
    locallyRecording: boolean;
    videoMuted: boolean;
    audioMuted: boolean;
    clientAudioMuted: boolean;
    clientRegistered: boolean;
    cameraBusy: boolean;

    confirmAudioMute: boolean;
    confirmVideoMute: boolean;
    confirmCameraSelection: string | null;
    showClientConnectionQualityWarning: boolean;

    canvasQuality: CanvasQuality;
}

export enum ApiErrorType {
    Unexpected = 0,
    NotFound = 1,
    BadRequest = 2,
    Unauthorized = 3,
}

export interface ApiError {
    isOccurring: boolean;
    internalErrorMessage: string | null;
    endUserErrorMessage: string | null;
    errorType: ApiErrorType | null;
}

export interface ApiErrorData {
    apiError: ApiError;
}

export interface OnPremiseSettings {
    onPremiseAppId: string;
    useOnPremiseServer: boolean;
}

export interface VideoFrameTagQueueMember {
    videoFrame: Blob;
    dateTaken: Date;
}

export interface VideoFrameTagQueue {
    isActivelyRecording: boolean;
    tagInProgress: boolean;
    membersToTag: VideoFrameTagQueueMember[];
}

export interface ConnectionQuality {
    value: number | null;
    consecutiveDrops: number | null;
    shouldDisplayWarning: boolean;
}

export interface SharedApplicationData {
    notifications: NotificationInfo[];
    connectionQuality: ConnectionQuality;
}

export interface NotificationInfo {
    message: SnackbarMessage;
    options: OptionsObject;
    key?: SnackbarKey;
    dismissed?: boolean;
}

export enum Alignment {
    Left = 0,
    Center = 1,
    Right = 2,
}

export interface Participant {
    id: string | undefined;
    firstName: string | null;
    lastName: string | null;
    role: ParticipantType | undefined;
    title: string | null;
    phoneNumber: string | null;
    email: string | null;
    photoUrl: string | null;
    accessHistory: AccessHistory;
    deviceId: string;
}

export interface AccessHistory {
    admittedUTC: Date | undefined;
    admittedBy: string | undefined;
    deniedUTC: Date | undefined;
    removedUTC: Date | undefined;
    removedBy: string | undefined;
    departedUTC: Date | undefined;
    previouslyAdmitted: boolean;
    previouslyDenied: boolean;
    previouslyRemoved: boolean;
}
